import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function GameCard({ game, rank }) {
  const [votes, setVotes] = useState([]);
  const  [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    // 1. Gestion des favoris
    const storedFav = JSON.parse(localStorage.getItem("favorites")) || [];
    setIsFavorite(storedFav.includes(game.id));

    // 2. Lecture de la note utilisateur
    const ratings = JSON.parse(localStorage.getItem("gamePulseVotes") || "{}");
    if (ratings[game.id]) {
      setVotes([ratings[game.id]]); 
    }
  }, [game.id]);

  // LOGIQUE DE CALCUL DU SCORE
  const averageRating = votes.length > 0 
    ? votes[0].toFixed(1) 
    : (game.rating ? Number(game.rating).toFixed(1) : "N/A");

  // --- SÉCURITÉS POUR LES DONNÉES ---
  
  // Plateforme : On affiche celle saisie en Admin (ex: PS5)
  const displayPlatform = game.platform || "Multi";

  // Genre
  const displayGenre = Array.isArray(game.genre) 
    ? game.genre.join(" / ") 
    : (game.genre || "Action");

  // Développeur
  const displayDeveloper = game.developer && typeof game.developer === 'object'
    ? game.developer.name
    : (game.developer || "Studio");

  // ✅ LOGIQUE DE PRIX (Promotion)
  // On calcule le pourcentage de réduction si un prix barré existe
  const discount = game.oldPrice && game.price 
    ? Math.round(((game.oldPrice - game.price) / game.oldPrice) * 100) 
    : null;

  return (
    <div className="modern-game-card">
      {/* Badge de classement (Top 3) */}
      {rank && <div className="rank-badge">#{rank}</div>}
      
      <Link to={`/game/${game.id}`} className="card-link">
        <div className="image-wrapper">
          {/* ✅ GESTION DES IMAGES : On prend la 1ère du tableau Cloudinary */}
          <img 
            src={game.images && game.images.length > 0 ? game.images[0] : (game.image || "/images/default.png")} 
            alt={game.title} 
            className="card-image" 
          />
          
          <div className="platform-tag">{displayPlatform}</div>
          
          {/* Badge de réduction dynamique */}
          {discount > 0 && <div className="promo-badge">-{discount}%</div>}
          
          <div className="user-score">⭐ {averageRating}</div>
        </div>

        <div className="card-details">
          <h3>{game.title}</h3>
          <p className="game-dev" style={{ fontSize: '0.8rem', opacity: 0.7 }}>
            {displayDeveloper}
          </p>
          <p className="game-genre">{displayGenre}</p>
          
          <div className="card-footer">
            <div className="price-container">
             {/* ✅ AFFICHAGE DU PRIX PROMO ET PRIX BARRÉ */}
<span className="price">
  {game.bestPrice && game.bestPrice !== "?" ? `${game.bestPrice}$` : "À venir"}
</span>
              {game.oldPrice && (
                <span className="old-price-card" style={{ textDecoration: 'line-through', fontSize: '0.8rem', opacity: 0.5, marginLeft: '8px' }}>
                  {game.oldPrice}€
                </span>
              )}
            </div>
            <span className="more-info">Détails →</span>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default GameCard;